import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { constants } from '@config';

const { pagePaddingInPx } = constants.text;

const Padding = styled.div`
  padding: ${pagePaddingInPx}px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
`;

const FitImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
`;

function ViewportPage ({
  height,
  width,
  thumbnail,
  children
}) {
  return (
    <Padding>
      <Wrapper style={{ width: `${width}px`, height: `${height}px` }}>
        {children}
        <FitImage src={thumbnail} />
      </Wrapper>
    </Padding>
  );
}

ViewportPage.propTypes = {
  thumbnail: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  children: PropTypes.node
};

export default ViewportPage;
